let wid = $WR.define('cheetahApplication/form/DesignerUEditorComp', [], function(require, exports, module) {
    const HTML = `
  <div class="x-field-editor">
    <div class="form-group">
        <label>域名</label>
        <input name="contentField" value="content" type="text" class="form-control" maxlength="30">
    </div>
    <div class="form-group">
    <label>宽度(百分比)</label>
    <input name="containerWidth" value="100%" type="text" class="form-control" maxlength="30">
    </div>
    <div class="form-group">
        <label>只读模式高度(数字)</label>
        <input name="editorReadHeight" value="305"  class="form-control" maxlength="30">
    </div>
    <div class="form-group">
        <label>编辑模式高度(数字)</label>
        <input name="editorHeight" value="280" class="form-control" maxlength="30">
    </div>
     <div class="form-group">
        <label>是否只读</label>
         <div class="controls row">
            <div class="col-sm-4"><label class="radio-inline"><input checked type="radio" value="0" name="isReadonly">否</label></div>
            <div class="col-sm-4"><label class="radio-inline"><input type="radio" value="1" name="isReadonly">是</label></div>
        </div>
    </div>
</div>
  `;
    var WidgetClass = require('cheetahApplication/form/UEditorComp');
    let Comp = MW.extend(require('designer/form/default/imbedded/ImbeddedField'), {
        defaults: {
            xtype: 'UEditorComp',
            label: '百度编辑器',
            xtypeName: '百度编辑器',
            isFormField: true
        },
        _getTpl: function() {
            return $(HTML)
        },
        getTargetWidgetClass: function() {
            return WidgetClass;
        }
    });

    module.exports = Comp;

});
$WR.defineType({
    id: wid,
    xtype: 'DesignerUEditorComp',
    designer: ''
});

wid = $WR.define('cheetahApplication/form/UEditorComp', [], function(require, exports, module) {
    const HTML = `
       <div class="EditorContainer" style="position: relative;z-index: 0;height:100%;"></div>
        `
    let Comp = MW.extend(require('form/default/ImbeddedField'), {
        protectedDefaults: {
            imbeddedObjId: 'pageData',
            pageType: "pageData"
        },
        constructor: function(config, owner) {
            var dd = config ? config.$dd || config : null;
            if (dd) dd.name = dd.name || dd.contentField;
            Comp.superclass.constructor.apply(this, arguments);
        },
        getCtHeight() {
            let el = this.el || $("div[wid='" + this.id + "']");
            return el.parent().height() || "100%";
        },
        getPageData() {
            let out = this;
            let $obj = {
                template: HTML,
                data: function() {
                    return {
                        editMode: false,
                        containerWidth: '100%',
                        isReady: false
                    }
                },
                created() {
                    let me = this;
                    if (me.$options.params)
                        me.params = me.$options.params;
                },
                mounted() {
                    let me = this;
                    this.$nextTick(function() {
                        let dd = {};
                        if (me.params.config) {
                            me.config = me.params.config;
                            if (me.config && me.config.getCurrentObject) {
                                me.dd = me.config.getCurrentObject().$dd;
                                me.editMode = !me.config.getCurrentObject().isTextMode();
                                if (me.dd)
                                    me.containerWidth = me.dd.containerWidth || '100%';
                            }
                            if (me.config && me.config.getForm) {
                                let form = me.config.getForm();
                                form.fireEvent("setUeditorInitParams", me.dd);
                            }
                        } else {
                            me.dd = {
                                editorReadHeight: me.params.editorReadHeight,
                                editorHeight: me.params.editorHeight,
                                contentField: me.params.contentField
                            }
                            me.editMode = me.params.editMode || true;
                        }
                        if (!me.dd.editorHeight) {
                            // me.dd.editorHeight = $(".EditorContainer").height();
                            me.dd.editorHeight = out.getCtHeight();
                        } else if (/%$/.test(me.dd.editorHeight)) {
                            me.dd.editorHeight = out.getCtHeight() * (Number(me.dd.editorHeight.replace("%", "")) / 100) - 35;
                        }
                        if (me.dd.editorHeight.toString().indexOf("px") > 0)
                            me.dd.editorHeight = me.dd.editorHeight.toString().substring(0, me.dd.editorHeight.toString().indexOf("px"));
                        if (me.dd.editorReadHeight && me.dd.editorReadHeight.toString().indexOf("px") > 0)
                            me.dd.editorReadHeight = me.dd.editorReadHeight.toString().substring(0, me.dd.editorReadHeight.toString().indexOf("px"));
                        if (me.dd.isReadonly && me.dd.isReadonly == "1")
                            me.editMode = false;
                        me.loadEditor();
                    })

                },
                methods: {
                    loadEditor() {
                        let me = this;
                        me.containerId = $uuid();
                        $(this.$el).html("<script type='text/plain'  id=" + me.containerId + "></script>");
                        let formId, businessId, tempBusinessId;

                        if (me.config && me.config.getForm) {
                            let form = me.config.getForm();
                            if (form.getExtForm) {
                                let extForm = form.getExtForm();
                                formId = extForm.formId || "";
                                businessId = extForm.businessId || "";
                                tempBusinessId = extForm.tempBusinessId || "";
                            }
                        } else {
                            formId = me.params.formId || "";
                            businessId = me.params.businessId || "";
                            tempBusinessId = me.params.tempBusinessId || "";
                        }
                        let url = PF.url("/cheetah/service/ckeditorService.saveUeditorEfile?type=JOA_EDITOR&formId=" + formId + "&businessId=" + businessId + "&tempBusinessId=" + tempBusinessId);
                        PF.requireJs(["/assets/js/ueditor/ueditor.config.js",
                            "/assets/js/ueditor/ueditor.all.js"
                        ], function() {
                            me.editor = UE.getEditor(me.containerId, {
                                zIndex: 9999,
                                initialFrameHeight: me.editMode ? me.dd.editorHeight : me.dd.editorReadHeight,
                                initialFrameWidth: me.containerWidth,
                                autoHeightEnabled: false,
                                autoFloatEnabled: false,
                                elementPathEnabled: false,
                                readonly: !me.editMode,
                                toolbars: !me.editMode ? [] : [
                                    ['undo', 'redo',
                                        '|', 'bold', 'italic', 'underline',
                                        '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify',
                                        '|', 'fontfamily', 'fontsize', 'forecolor', 'backcolor',
                                        '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', 'indent',
                                        '|', 'insertorderedlist', 'insertunorderedlist', 'insertimage', 'inserttable', 'fullscreen'
                                    ] //'|', 'insertimage'
                                ],
                                contextMenu: (!me.editMode ? [] : ""),
                                wordCount: false,
                                imageUrl: url
                            });
                            me.editor.addListener("contentChange", function() {
                                var content = me.editor.getContent();
                                if (me.config && me.config.getForm) {
                                    let form = me.config.getForm();
                                    form.setValueByName(me.dd.contentField, content);
                                }
                            });
                            // TIPS:
                            // 对于52.3.0及以下版本的火狐浏览器,在编辑器内插入表格,再在表格内输入中文(即使用空格确定)时,无法触发监听事件contentChange
                            // 所以此处添加wordCount事件的监听,暂未遇到其他兼容性问题
                            // 经过初步测试,使用wordCount监听,可以兼容contentChange事件(即触发contentChange事件时,百分百触发wordCount事件)
                            // 因暂时没测试除文字外的效果,故此先保留contentChange事件的监听
                            // by hyg 2019-10-26 11:11:07
                            me.editor.addListener("wordCount", function(params) {
                                var content = me.editor.getContent();
                                if (me.config && me.config.getForm) {
                                    let form = me.config.getForm();
                                    form.setValueByName(me.dd.contentField, content);
                                }
                            });
                            me.editor.ready(function() {
                                out.editor = me.editor;
                                if (out._value) {
                                    out.setValue(out._value)
                                }
                                if (out._height) {
                                    out.setValue(out._height)
                                }
                                var content = "";
                                var config = me.params.config;
                                if (config && config.getFormValue) {
                                    var formValue = config.getFormValue();
                                    content = formValue[me.dd.contentField || "content"];
                                } else {
                                    content = me.params.content || "";
                                }
                                if (content) {
                                    me.editor.setContent(content);
                                }
                                //禁止拖动插入图片
                                UE.dom.domUtils.on(me.editor.body, "drop", function(e) {
                                    setTimeout(function() {
                                        var cont = me.editor.getContent();
                                        if (cont.indexOf('<img src=') != -1) {
                                            cont = cont.replace(/<div><img.*><\/div>/g, "");
                                            me.editor.setContent(cont);
                                            me.editor.focus(true);
                                        }
                                    }, 0);
                                });

                            });

                        })
                    }
                },
                destroyed() {
                    if (this.editor) {
                        try {
                            this.editor.destroy();
                        } catch (e) {}
                    }
                }
            }
            return $obj;
        },
        isFormField() {
            return false;
        },
        _renderTextModeBody(dd, fnMount) {
            return this._renderBody(dd, fnMount);
        },
        _destroy() {
            if (this.editor) {
                this.editor.destroy();
            }
            Comp.superclass._destroy.apply(this, arguments);
        },
        getValue() {
            if (this.editor) {
                return this.editor.getContent();
            }
            return this._value || "";
        },
        reset(value) {
            if (this.editor) {
                this.editor.setContent(value);
            }
        },
        setValue(value) {
            if (this.editor) {
                this.editor.setContent(value || '');
            } else {
                this._value = value;
            }
        },
        setHeight(height) {
            if (this.editor && height) {
                this.editor.setHeight(height);
            } else {
                this._height = height || 300;
            }
        }

    });
    module.exports = Comp;
});

$WR.defineType({
    id: wid,
    xtype: 'UEditorComp',
    designer: 'DesignerUEditorComp'
});



// WEBPACK FOOTER //
// ./src/common/formWidget/uEditor.js